module.exports = __webpack_public_path__ + "static/media/shivashankar.a60a5ab6.png";